<!-- <div class="notification-modal">
  <div class="form-card p-4">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="modal-title">Notification</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
    </div>

    <div class="card notif-card mt-4 p-3 mb-2 ">
      <div class="d-flex justify-content-between align-items-center">
        <small>10:30 AM</small>
        <button type="button" class="btn-close small" aria-label="Close"></button>
      </div>
      <p class="fw-semibold mt-1 mb-2">New Domestic Worker Request</p>
      <div class="row text-muted">
        <div class="col">
          <div class="small">Gender</div>
          <div class="fw-semibold">Female</div>
        </div>
        <div class="col">
          <div class="small">Nationality</div>
          <div class="fw-semibold tdata">India</div>
        </div>
        <div class="col">
          <div class="small">Profession</div>
          <div class="fw-semibold">Housekeeper</div>
        </div>
      </div>
    </div>
    <div class="card notif-card mt-4 p-3 mb-2 ">
      <div class="d-flex justify-content-between align-items-center">
        <small>10:30 AM</small>
        <button type="button" class="btn-close small" aria-label="Close"></button>
      </div>
      <p class="fw-semibold mt-1 mb-2">Complaint raised by a customer for delay in onboarding</p>
      <div>
        <p class="font-regular">It is a long established fact that a reader will be distracted by the readable content
          of a page when looking
          at its layout.</p>
      </div>
    </div>
    <div class="card notif-card mt-4 p-3 mb-2 ">
      <div class="d-flex justify-content-between align-items-center">
        <small>10:30 AM</small>
        <button type="button" class="btn-close small" aria-label="Close"></button>
      </div>
      <p class="fw-semibold mt-1 mb-2">Reminder! Your password expiring in 3 days.</p>
      <div>
        <p class="font-regular">Kindly update your password for an uninterrupted access.</p>
      </div>
    </div>
  </div>
</div> -->
<div class="norecordfound-block text-center py-4 text-muted">
  <i class="fa-regular fa-face-smile fs-3 mb-2"></i>
  <h4 class="text-900 font-bold text-3xl lg:text-5xl mb-2">Coming Soon</h4>
</div>

